import styled from 'styled-components';
import { Box } from '@interstate/components/Box';

import { MAX_APP_CONTAINER_WIDTH_NEW } from '@makemydeal/dr-shared-ui-utils';

export const RouteContainer = styled.div`
    max-width: ${MAX_APP_CONTAINER_WIDTH_NEW};
    margin: 0 auto;
    padding: 0 16px;
    padding-top: 16px;
`;

export const LoadingIndicatorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    #ids-spinner-root {
        margin-bottom: 20px;
    }
`;

export const BaseHeaderTitle = styled.h1`
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0;
`;

export const StyledVehicleWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex-grow: 1;
    justify-content: space-between;
    margin-top: 1rem;
    margin-bottom: 1rem;

    ${({ theme }) => theme.breakpoints.up('md')} {
        flex-direction: row;
    }
`;

export const StyledHeaderWrapper = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
`;
